import React, { useState } from "react";
import {
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  CircularProgress
} from "@mui/material";
// import { Box, Container } from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { register } from "../../../../core/redux/action/auth";

import FormInformation from "./Forms/FormInformation";
import MentorInformation from "./Forms/MentorInformation";
import WorkingExperience from "./Forms/WorkingExperience";

import RegisterSuccessMentor from "./RegisterSuccess";

import validationSchema from "./FormModel/validationSchema";
import mentorFormModel from "./FormModel/mentorFormModel";
import formInitialValues from "./FormModel/formInitialValues";

import useStyles from "./styles";

const steps = [
  "Personal Information",
  "Mentor Information",
  "Working Experience"
];
const { formId, formField } = mentorFormModel;

function _renderStepContent(step) {
  switch (step) {
    case 0:
      return <FormInformation formField={formField} />;
    case 1:
      return <MentorInformation formField={formField} />;
    case 2:
      return <WorkingExperience formField={formField} />;
    default:
      return <>Not Found</>;
  }
}

export default function RegisterMentor() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    for (const [key, value] of Object.entries(values)) {
      formData.append(key, value ? value : "");
    }
    //phd
    formData.append("role", 4);

    dispatch(register(formData));

    await _sleep(1000);
    actions.setSubmitting(false);
    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  return (
    <Container>
      <Box sx={{ textAlign: "center" }}>
        <>
          <Typography component="h1" variant="h4" align="center">
            Registration for C2F Mentor
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <>
            {activeStep === steps.length ? (
              <RegisterSuccessMentor />
            ) : (
              <Formik
                initialValues={formInitialValues}
                validationSchema={currentValidationSchema}
                onSubmit={_handleSubmit}
              >
                {({ isSubmitting }) => {
                  return (
                    <Form id={formId}>
                      {_renderStepContent(activeStep)}

                      <div className={classes.buttons}>
                        {activeStep !== 0 && (
                          <Button
                            onClick={_handleBack}
                            className={classes.button}
                          >
                            Back
                          </Button>
                        )}
                        <div className={classes.wrapper}>
                          <Button
                            disabled={isSubmitting}
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.button}
                          >
                            {isLastStep ? "Submit" : "Next"}
                          </Button>
                          {isSubmitting && (
                            <CircularProgress
                              size={24}
                              className={classes.buttonProgress}
                            />
                          )}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            )}
          </>
        </>
      </Box>
    </Container>
  );
}
